export default __webpack_public_path__ + "static/media/MinorInjuryUnits(MIU)v5.1220706MinorinjuryguidelineV5_1_flowchart.eca31a4e.jpg";